import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'checkValueLessThanZero',
  standalone: true
})
export class ValueLessThanZeroPipe implements PipeTransform {

  transform(value: any, args?: any): any {

    if(value == -1) return "_";

    else return value||"_";

  }

}
